<template>
	<v-card class="elevation-0 attendees-page attendees-page-container page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<div class="d-flex">
				<v-skeleton-loader
					v-if="isLoading"
					v-bind="attrs"
					width="600"
					type="list-item, list-item-three-line, card-heading"
				>
				</v-skeleton-loader>
	
				<div v-else style="width: 100%">
					<div class="mb-4">
						<ButtonBack />
					</div>
	
					<div class="attendees-page__title">Attendees</div>
	
					<div v-for="(attend, index) in attendees" :key="index">
						<AttendCard :user="attend "/>
					</div>
	
					<div
						class="d-flex my-9 justify-center home-page__pagination"
						v-if="!isLoading && attendees.length > 0"
					>
						<Pagination 
							:page="filters.page"
							:pageCount="+this.pageCountAttendees"
							v-on:pageChange="onPageChange"
						/>
					</div>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AttendCard from '@/components/Event/AttendCard'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'
import ButtonBack from '@/components/ButtonBack'
import Block from '@/mixins/Block.js'

export default {
	name: 'AttendeesPage',
	mixins: [Block],
	components: {
		AttendCard,
		Pagination,
		PageBlocked,
		ButtonBack
	},
	methods: {
		...mapActions('event', ['getAttendeesEvent']),

		onPageChange(page) {
			if (this.filters.page !== page) {
				const params = {
					page
				}
				this.filters.page = page
				const queryString = this.formatFilters(params)
				this.getAttendees(queryString)
			} 
		},

		formatFilters(filters) {
			const { page } = filters

			let queryString = `&event_id=${this.$route.params.id}&page=${page}&filter=event`

			return queryString
		},

		async getAttendees(additionalQueryParams = '') {
			await this.getAttendeesEvent(additionalQueryParams)
		},
	},

	created() {
		if (this.eventSettings && this.eventSettings.show_attendees) {
			if (this.$route.params.id !== undefined) {
				this.getAttendeesEvent(`&event_id=${this.$route.params.id}&filter=event`)
			}
		} else {
			this.$router.push('/')
		}
	},

	computed: {
		...mapGetters('event', ['isLoading', 'pageCountAttendees', 'attendees']),
		...mapGetters('settings', ['eventSettings'])
	},

	data() {
		return {
			attrs: {
				elevation: 0,
			},
			filters: {
				page: 1,
			},
			pageBlockedName: 'events'
		}
	},
}
</script>

<style lang="scss">
.attendees-page {
	background: #f1f1f1 !important;
	max-width: 600px;
	width: 100%;

	&__title {
		color: rgb(74, 74, 74);
		font-size: 18px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		margin-bottom: 10px;
	}
}
</style>
